const SET_USER_PROFILE = 'SET_USER_PROFILE';
const SET_SOLID_USER_PROFILE = 'SET_SOLID_USER_PROFILE';
const SET_USER_WEBID = 'SET_USER_WEBID';
const SET_USER_SOLID_NAME = 'SET_USER_SOLID_NAME';
const SET_USER_SOLID_PROFILE_IMAGE = 'SET_USER_SOLID_PROFILE_IMAGE';
const ADD_DISCOVERY_SESSION = 'ADD_DISCOVERY_SESSION';
const ADD_EXECUTION_SESSION = 'ADD_EXECUTION_SESSION';
const DELETE_DISCOVERY_SESSION = 'DELETE_DISCOVERY_SESSION';
const DELETE_EXECUTION_SESSION = 'DELETE_EXECUTION_SESSION';
const UPDATE_EXECUTION_SESSION = 'UPDATE_EXECUTION_SESSION';
const UPDATE_DISCOVERY_SESSION = 'UPDATE_DISCOVERY_SESSION';
const UPDATE_APPLICATIONS_FOLDER = 'UPDATE_APPLICATIONS_FOLDER';
const SET_USER_SOLID_IMAGE = 'SET_USER_SOLID_IMAGE';
const SET_USER_INBOX_INVITATIONS = 'SET_USER_INBOX_INVITATIONS';
const SET_LIGHT_COLOR_THEME = 'SET_LIGHT_COLOR_THEME';

export default {
  SET_USER_PROFILE,
  SET_SOLID_USER_PROFILE,
  SET_USER_WEBID,
  SET_USER_SOLID_PROFILE_IMAGE,
  SET_USER_SOLID_NAME,
  SET_USER_SOLID_IMAGE,
  ADD_DISCOVERY_SESSION,
  ADD_EXECUTION_SESSION,
  DELETE_DISCOVERY_SESSION,
  DELETE_EXECUTION_SESSION,
  UPDATE_DISCOVERY_SESSION,
  UPDATE_EXECUTION_SESSION,
  UPDATE_APPLICATIONS_FOLDER,
  SET_USER_INBOX_INVITATIONS,
  SET_LIGHT_COLOR_THEME
};
